import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'

type Props = {
  title: string
  tooltip?: React.ReactNode
  children: React.ReactNode
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export const PairInformationPoolItem: React.FC<Props> = ({
  title,
  children,
  tooltip,
  onMouseEnter,
  onMouseLeave,
  ...restProps // restProps is for tooltip
}) => {
  return (
    <Root
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...restProps}
    >
      <Tooltip content={tooltip}>
        <Title>{title}</Title>
      </Tooltip>
      <Value>{children}</Value>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  align-items: center;

  gap: 8px;
`

const Title = styled.div`
  color: var(--text-9);

  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  white-space: nowrap;
`

const Value = styled.div`
  color: var(--white);

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
  white-space: nowrap;
  justify-content: start;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  align-items: center;

  gap: 3px;
`
